// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"8e6cb91d","5":"b7ac3d44","16":"15a0bd1a","56":"791d7a03","58":"2ce22f81","172":"14ca81ba","182":"6a888a65","326":"271170bd","552":"b2613d78","913":"05ee117e","940":"b9b7354f","982":"e3505006"}[chunkId] + ".chunk.js";
};